import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "announcer-overlay"
}
const _hoisted_2 = { class: "announcer-content" }
const _hoisted_3 = { class: "announcer-title" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhaseAnnouncer',
  props: {
    show: { type: Boolean },
    title: {},
    subtitle: {},
    isRole: { type: Boolean },
    role: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const subtitleClasses = computed(() => {
    const classes = ['announcer-subtitle'];
    if (props.role === 'mafia' || props.role === 'whore') {
        classes.push('role-mafia');
    } else {
        classes.push('role-citizen');
    }
    return classes;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "announcer-fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
              (_ctx.subtitle)
                ? (_openBlock(), _createElementBlock("h2", {
                    key: 0,
                    class: _normalizeClass(subtitleClasses.value)
                  }, _toDisplayString(_ctx.subtitle), 3))
                : _createCommentVNode("", true),
              (_ctx.isRole)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
                    class: "btn"
                  }, "Продолжить"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})